import { render, staticRenderFns } from "./FormFiltroProgramacaoUnidade.vue?vue&type=template&id=be5535b4&scoped=true"
import script from "./FormFiltroProgramacaoUnidade.vue?vue&type=script&lang=js"
export * from "./FormFiltroProgramacaoUnidade.vue?vue&type=script&lang=js"
import style0 from "./FormFiltroProgramacaoUnidade.vue?vue&type=style&index=0&id=be5535b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be5535b4",
  null
  
)

export default component.exports